export default __webpack_public_path__ + "static/media/ispo-bg-2x.30ec0379.jpg";